import { LeadCategory } from 'types/enums/LeadCategory'
import LeadsAction from 'store/leads/LeadsAction'
import OpportunitiesAction from 'store/opportunities/OpportunitiesAction'
import { useTypedSelector } from 'helpers/reducers'

export const useLeadContext = (category?: LeadCategory | string) => {
    const isOpportunity = category === LeadCategory.Opportunity || category === 'opportunity'
    
    const state = useTypedSelector((s) => 
        isOpportunity ? s.opportunitiesState : s.leadsState
    )
    
    const actions = isOpportunity ? OpportunitiesAction : LeadsAction
    
    return {
        state,
        actions,
        isOpportunity
    }
}
